
import { useState } from 'react';
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

interface UseFileUploadResult {
  selectedFile: File | null;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  uploadFile: () => Promise<string | null>;
  clearSelectedFile: () => void;
}

export function useFileUpload(): UseFileUploadResult {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const { toast } = useToast();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    const supportedFileTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'image/tiff'];
    
    if (file && supportedFileTypes.includes(file.type)) {
      setSelectedFile(file);
    } else {
      toast({
        variant: "destructive",
        title: "Invalid File",
        description: "Please select a supported file type (PDF, JPG, PNG, TIFF)",
      });
    }
  };

  const uploadFile = async (): Promise<string | null> => {
    if (!selectedFile) return null;

    const fileName = `${Date.now()}-${selectedFile.name}`;
    const { data: uploadData, error: uploadError } = await supabase.storage
      .from('knowledge_pdfs')
      .upload(fileName, selectedFile);

    if (uploadError) throw uploadError;

    const { data: { publicUrl } } = supabase.storage
      .from('knowledge_pdfs')
      .getPublicUrl(fileName);

    return publicUrl;
  };

  const clearSelectedFile = () => setSelectedFile(null);

  return {
    selectedFile,
    handleFileChange,
    uploadFile,
    clearSelectedFile
  };
} 
